import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import StickyCall from "../components/StickyCall";
import GoogleReviews from "../components/GoogleReviews";
import HeroSection from "../components/home/HeroSection";
import AboutSection from "../components/home/AboutSection";
import { DomainesSection, ServicesGridSection, FeaturedRowsSection } from "../components/home/ContentSections";
import CitiesSection from "../components/home/CitiesSection";
import TrustBadgesSection from "../components/home/TrustBadgesSection";
import TarifsSection from "../components/home/TarifsSection";
import FAQSection from "../components/home/FAQSection";
import CTASection from "../components/home/CTASection";
import LatestArticlesSection from "../components/home/LatestArticlesSection";

export default function Home() {
  return (
    <div>
      <Header />
      <StickyCall />

      <HeroSection />
      <AboutSection />
      <DomainesSection />
      <ServicesGridSection />
      <FeaturedRowsSection />
      <CitiesSection />
      <TrustBadgesSection />
      <GoogleReviews />
      <TarifsSection />
      <FAQSection />
      <LatestArticlesSection />
      <CTASection />

      <Footer />
    </div>
  );
}
